
export default function Hero() {
  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-[85vh] flex flex-col items-center justify-center px-8 pt-20"
    >
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-light leading-relaxed text-[#2C2C2C] mb-8" style={{ fontFamily: 'Georgia, serif' }}>
          Experience the healing touch of{' '}
          <span className="text-[#A8B5A0]">therapeutic massage</span> and restore your{' '}
          <span className="text-[#A8B5A0]">body & mind</span>
        </h1>

        <button
          onClick={scrollToAbout}
          className="mt-12 px-12 py-4 border border-[#A8B5A0] text-[#A8B5A0] rounded-3xl text-sm hover:bg-[#A8B5A0] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          Book Your Session
        </button>

        <div className="mt-16 flex justify-center">
          <div className="animate-bounce">
            <i className="ri-arrow-down-line text-xl text-[#A8B5A0]"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
